var _mask, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPtBr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 512,
    height: 512,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "a"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 256,
    cy: 256,
    r: 256,
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#6da544",
    d: "M512 0v512H0l224-288Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffda44",
    d: "m346 166-122 58-58 122 90 66 212-156Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0052b4",
    d: "m319 193-95 31-31 95a89 89 0 0 0 136-12l14-34a89 89 0 0 0-24-80z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eee",
    d: "M255 257c29 9 55 26 74 50 7-10 12-22 14-34-17-18-38-32-62-42l-57-7Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 512 512 0H0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#496e2d",
    d: "M0 0v512l167-167 32-172L167 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d80027",
    d: "M167 0v167l89 89L512 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffda44",
    d: "M167 167a89 89 0 0 0-89 89 89 89 0 0 0 89 89l89-89a89 89 0 0 0-89-89z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d80027",
    d: "M117 212v55a50 50 0 1 0 100 0v-56H117Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#eee",
    d: "M167 284c-9 0-17-8-17-17v-22h34v22c0 9-8 17-17 17z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPtBr);
export default __webpack_public_path__ + "static/media/pt-br.d913be12816569e23598e2ab12ae985a.svg";
export { ForwardRef as ReactComponent };